import { Heading, Layout } from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";
import { getContractServices } from "../../data/contract";
import CheckboxCustom from "../generic/CheckboxCustom";
import { useFormikContext } from "formik";
import { IMatchMakerAnswers } from "../../interfaces";
import { AdditionalProductType } from "@bus/models";

export const Services = () => {
    const { t } = useTranslation(["question4page"]);
    const { values, setFieldValue } = useFormikContext<IMatchMakerAnswers>();
    const handleOnChange = (e: string) => {
        let currentValues = [...(values["services"] || [])];
        if (currentValues.includes(e as AdditionalProductType)) {
            currentValues.splice(currentValues.indexOf(e as AdditionalProductType), 1);
        } else {
            currentValues.push(e as AdditionalProductType);
        }
        setFieldValue("services", currentValues);
    };
    return (
        <>
            <Heading level={2} className="u-font-size-fs2">{t("question4page:services.title")}</Heading>
            <Layout>
                {getContractServices(t).map((serv, index) => (
                    <CheckboxCustom
                        handleOnChange={handleOnChange}
                        values={values}
                        defaultOption="1/1"
                        key={"services" + index}
                        item={serv}
                        fieldName="services"
                        className={'u-text-left'}
                    />
                ))}
            </Layout>
        </>
    );
};
